import { render, staticRenderFns } from "./hierarchy2.vue?vue&type=template&id=aaa20e4a&scoped=true"
import script from "./hierarchy2.vue?vue&type=script&lang=js"
export * from "./hierarchy2.vue?vue&type=script&lang=js"
import style0 from "./hierarchy2.vue?vue&type=style&index=0&id=aaa20e4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa20e4a",
  null
  
)

export default component.exports